"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatHeader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _useSidepane = require("../AppData/useSidepane");
var _constants = require("../../common/constants");
var _ChatSelector = require("./ChatSelector");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ChatHeader = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var selection = _ref.selection,
    selectorOpen = _ref.selectorOpen,
    onToggle = _ref.onToggle,
    onSelect = _ref.onSelect,
    role = _ref.role,
    peerId = _ref.peerId;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var toggleChat = (0, _useSidepane.useSidepaneToggle)(_constants.SIDE_PANE_OPTIONS.CHAT);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    onClick: onToggle,
    align: "center",
    css: {
      color: "$textPrimary",
      h: "$16",
      mb: "$2"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      variant: "h6",
      children: "Chat "
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Root, {
      open: open,
      onOpenChange: function onOpenChange(value) {
        return setOpen(value);
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Trigger, {
        asChild: true,
        "data-testid": "participant_list_filter",
        css: {
          border: "1px solid $textDisabled",
          r: "$0",
          p: "$2 $4",
          ml: "$8"
        },
        tabIndex: 0,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
          align: "center",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
            variant: "sm",
            css: _objectSpread({}, (0, _reactUi.textEllipsis)(80)),
            children: selection
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
            css: {
              ml: "$2",
              color: "$textDisabled"
            },
            children: open ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronUpIcon, {
              width: 14,
              height: 14
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronDownIcon, {
              width: 14,
              height: 14
            })
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Content, {
        css: {
          w: "$64",
          overflow: "hidden",
          maxHeight: "unset"
        },
        align: "start",
        sideOffset: 8,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatSelector.ChatSelector, {
          onSelect: onSelect,
          role: role,
          peerId: peerId
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.IconButton, {
      css: {
        ml: "auto"
      },
      onClick: function onClick(e) {
        e.stopPropagation();
        selectorOpen ? onToggle() : toggleChat();
      },
      "data-testid": "close_chat",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.CrossIcon, {})
    })]
  });
});
exports.ChatHeader = ChatHeader;